import { useReduxState } from "../../explorer/redux/hooks";
import { defaultBrand } from "../../site/configuration/defaultSettings";
import { reduxStoreConfig } from "../../site/configuration/reduxStoreConfig";
import { Brand, NavigationState } from "../types";
import { AppInfo } from "../types/System/AppInfo";
import useAppContext from "./useAppContext";
import { useAppInfo } from "./useAppInfo";

const useBrands: () => {
  currentBrandUrl: string;
  currentBrand: Brand | undefined;
  brands: Brand[];
} = () => {
  const [navigationState] = useReduxState<NavigationState>(
    reduxStoreConfig.systemNavigationState
  );
  const [appInfo] = useAppInfo();
  const currentAppContext = useAppContext().currentContext;
  const brands = appInfo && appInfo.appContexts ? appInfo.appContexts.find(c => c.code.toLocaleLowerCase() === currentAppContext)?.brands : [];

  const currentBrandUrl = navigationState.brand ?? defaultBrand;

  return {
    currentBrandUrl,
    currentBrand: brands?.find(b => b.code === currentBrandUrl),
    brands: brands ?? [],
  };
};
export default useBrands;
